import {
  tokenLogin,
  simpleLogin,
  modifyPassword,
  dynamicLogin,
  qrcodeLogin,
  refreshToken,
  logout,
} from "@/api/login";
import { getUserInfo, switchAccount } from "@/api/user";
import { getLoginQRCode, getBindQRCode } from "@/api/weixin";
import {
  getToken,
  setToken,
  removeToken,
  setUser,
  getUser,
  removeUser,
  setTokenFailureTime,
  removeTokenFailureTime,
  // getQrcode
  // setQrcode
} from "@/utils/auth";
import { sentBuryPointInfo } from "@/utils/buryPoint";
import { resetRouter } from "@/router";
import { getAuthProducts } from "@/api/apps";
function callback(commit, data) {
  if (data && data.token) {
    commit("SET_TOKEN", data.token);
    // 用户信息
    const user = {
      userId: data.userId,
      username: data.userNm,
      realName: data.realNm,
      companyName: data.compNm,
      expireDate: data.actvToYmd,
      token: data.token,
    };
    commit("SET_USER", user);
    commit("SET_USERINFO", {});
  }
}

export default {
  namespaced: true,
  state: {
    token: getToken() || "",
    user: getUser() || "",
    userInfo: {
      wxNickNm: "",
      headPicPath: "",
      bindInfoDTO: {},
      bindQrcode: "",
    },
    qrcode: "",
    qrcodeId: "",
    products: [], // 分组后的应用
    menus: [], // 单个应用的菜单
    microAppRoutes: [], // 应用路由
    roles: [],
    passwordFree: false,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
      setToken(token);
    },
    SET_USER: (state, user) => {
      state.user = user;
      setUser(user);
    },
    SET_USERINFO: (state, data) => {
      if (Object.keys(data).length > 0) {
        state.userInfo = {
          ...state.userInfo,
          ...data,
        };
      } else {
        state.userInfo = {};
      }
    },
    SET_QRCODE: (state, { qrcode, qrcodeId }) => {
      state.qrcode = qrcode;
      state.qrcodeId = qrcodeId;
    },
    SET_ROUTES(state, data) {
      state.microAppRoutes = data;
    },
    SET_PASSWORDFREE(state, data) {
      state.passwordFree = data;
    },
    // 推入用户应用
    ADD_USER_PRODUCTS(state, data) {
      state.products = data;
    },
  },

  actions: {
    // token 自动登录
    async tokenLogin({ commit }, token) {
      try {
        const res = await tokenLogin(token);
        callback(commit, res?.data?.data || {});
        return Promise.resolve(res);
      } catch (error) {
        return Promise.reject(error);
      }
    },
    simpleLogin({ commit }, data) {
      return new Promise((resolve, reject) => {
        simpleLogin(data)
          .then((response) => {
            const { data, status } = response.data || {};
            // if (!data.token) reject(response);
            removeTokenFailureTime();
            setTokenFailureTime();
            if (status.status === 0) callback(commit, data);
            resolve(response);
          })
          .catch((response) => {
            reject(response);
          });
      });
    },
    modifyPassword({ commit }, data) {
      return new Promise((resolve, reject) => {
        modifyPassword(data)
          .then((response) => {
            const { data, status } = response.data || {};
            // if (!data.token) reject(response);
            removeTokenFailureTime();
            setTokenFailureTime();
            if (status.status === 0) callback(commit, data);
            resolve(response);
          })
          .catch((response) => {
            reject(response);
          });
      });
    },

    dynamicLogin({ commit }, data) {
      return new Promise((resolve, reject) => {
        dynamicLogin(data)
          .then((response) => {
            const { data, status } = response.data;
            // if (!data.token) reject(response);
            removeTokenFailureTime();
            setTokenFailureTime();
            if (status.status === 0) callback(commit, data);
            resolve(response);
          })
          .catch((response) => {
            reject(response);
          });
      });
    },

    qrcodeLogin({ commit }, data) {
      return new Promise((resolve, reject) => {
        qrcodeLogin(data)
          .then((response) => {
            const { data, status } = response.data;
            // if (!data.token) reject(response);
            removeTokenFailureTime();
            setTokenFailureTime();
            if (status.status === 0) callback(commit, data);
            resolve(response);
          })
          .catch((response) => {
            reject(response);
          });
      });
    },

    switchAccount({ commit }, data) {
      return new Promise((resolve, reject) => {
        switchAccount(data)
          .then((response) => {
            const { data } = response.data;
            // if (!data.token) reject(response);
            callback(commit, data);
            resolve(response);
          })
          .catch((response) => {
            reject(response);
          });
      });
    },

    getLoginQRCode({ commit }, data) {
      return new Promise((resolve, reject) => {
        getLoginQRCode(data)
          .then((response) => {
            const { data } = response.data || {};
            commit("SET_QRCODE", {
              qrcode: data.qrcode,
              qrcodeId: data.qrcodeId,
              expireTime: data.expireTime,
            });
            resolve(data);
          })
          .catch((response) => {
            reject(response);
          });
      });
    },

    // get user info
    getUserInfo({ commit }) {
      return new Promise((resolve, reject) => {
        getUserInfo()
          .then((response) => {
            const { data } = (response && response.data) || {};

            if (!data) {
              reject("Verification failed, please Login again.");
            }
            const userInfo = {
              ...data,
            };
            commit("SET_USERINFO", userInfo);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    getBindQRCode({ commit, state }) {
      return new Promise((resolve, reject) => {
        getBindQRCode(state)
          .then((response) => {
            const { data } = response.data || {};
            commit("SET_USERINFO", { bindQrcode: data || {} });
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // user logout
    async logout({ dispatch, commit }) {
      await logout(); // 让后台使token失效
      commit("SET_TOKEN", "");
      commit("SET_USER", "");
      commit("SET_ROUTES", []);
      removeToken();
      removeUser();
      resetRouter();
      dispatch(
        "resetAllState",
        {
          user: {
            token: "",
            user: "",
          },
          portal: {
            authProducts: [],
            productsData: [],
            solutionsData: [],
          },
        },
        { root: true }
      );

      sentBuryPointInfo({
        eventName: "点击登出",
        eventCode: "click",
        rsCode: "iways-logout",
        rsName: "点击登出",
        eventContext: {
          url: "/",
        },
      });
    },

    // remove token
    async resetToken({ commit }) {
      await logout(); // 让后台使token失效
      await new Promise((resolve) => {
        commit("SET_TOKEN", "");
        commit("SET_USER", {});
        removeToken();
        removeUser();
        resolve();
      });
    },

    refreshToken({ commit, state }) {
      return new Promise((resolve, reject) => {
        const { token, user } = state;
        refreshToken({
          deviceId: 1234,
          refreshToken: token,
        })
          .then((response) => {
            const { data } = response.data || {};
            if (data && data.token) {
              commit("SET_TOKEN", data.token);
              user.token = data.token;
              commit("SET_USER", user);
            }
            resolve(response);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    setRoutes({ commit }, data) {
      commit("SET_ROUTES", data);
    },

    getAuthProducts({ commit }) {
      return new Promise((resolve, reject) => {
        getAuthProducts()
          .then((response) => {
            const { data } = (response && response.data) || {};
            commit("ADD_USER_PRODUCTS", data);
            resolve(data);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },
  },
};
